<template>
  <div>
    <div class="w-layout-grid grid-4 coverings_grid_desktop">
      <div class="coverings_bloc_1 covers_top_bar">
        <h1 class="heading-8">{{ $t('COVERS') }}</h1>
        <p class="bold_label">{{ $t('COVERS_ANALYTICS_BASED_ON_PACKAGE') }}</p>
      </div>
      <div :class="['coverings_bloc_1  covers_top_bar', item.ZZSELECTED_IND ? 'covering_bloc_featured' : '']" v-for="item in data.CT_PACKAGES" :key="item.PACKAGE_ID">
        <div class="interior_bloc_cover_up">
          <h1 class="heading-8">{{ item.PACKAGE_DESC }}</h1>
          <!-- <p class="bold_label paragraph_coverings">{{ item.PACKAGE_TEXT }}</p> -->
        </div>
        <div class="interior_bloc_cover_down">
          <h1 class="heading-8 covering_pricing">{{ $u.formatMoney(item.AMOUNT) }}</h1>
          <button type="button" class="button_extra_small button_extra_small_coverings w-button" @click="selectPackage(item)">{{ $t('BUY') }}</button>
        </div>
      </div>
      <template v-for="cover in getMandatoryCovers">
        <div class="coverings_bloc_1 covers_side_bar" :key="cover.COVER_ID">
          <div class="columns-9 w-row">
            <div class="w-col w-col-10">
              <h1 class="heading-8 heading_2_covering">{{ cover.COVER_DESC }}</h1>
            </div>
            <div class="w-col w-col-2"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
          </div>
        </div>
        <div :class="['coverings_bloc_1', item.ZZSELECTED_IND ? 'covering_bloc_featured' : '']" v-for="item in data.CT_PACKAGES" :key="`${item.PACKAGE_ID}${cover.COVER_ID}`">
          <img v-if="isCoverinPackage(cover.COVER_ID, item.PACKAGE_ID)" src="@/assets/images/Path.svg" loading="lazy" width="28" alt="" class="image-10" />
        </div>
      </template>
    </div>
    <div class="coverings_optionals_bloc w-form">
      <validation-observer v-slot="{ handleSubmit, reset }">
        <form @submit.prevent="handleSubmit(submitForm)" @reset.prevent="reset" id="email-form" name="email-form" data-name="Email Form" class="form-3">
          <div id="w-node-_3da707ba-a973-bc1e-67ce-f772b18558fd-f551e205" class="coverings_bloc_1 covering_bloc_transparent">
            <h1 class="heading-8">{{$t('OPTIONAL_COVERS')}}</h1>
          </div>
          <div id="w-node-a6edec43-bfa3-034f-a4f7-fae1c1284df3-f551e205" class="coverings_bloc_1 covering_bloc_transparent"></div>
          <div id="w-node-_7c4956fb-0347-dff0-4d4c-36ba1ba69ed0-f551e205" class="coverings_bloc_1 covering_bloc_transparent"></div>
          <div id="w-node-_5dffc8b7-6c1a-2790-ad8b-2fe940621fde-f551e205" class="coverings_bloc_1 covering_bloc_transparent"></div>
          <div id="w-node-a6da3176-fa34-fe5c-d2de-71fee105f491-f551e205" class="coverings_bloc_1 covering_bloc_transparent"></div>
          <template v-for="cover in getOptionalCovers">
            <div id="w-node-_166edab8-8a9c-58a4-5e5a-eb82f162104b-f551e205" class="coverings_bloc_1" :key="cover.COVER_ID">
              <div class="columns-9 w-row">
                <div class="w-col w-col-10">
                  <h1 class="heading-8 heading_2_covering">{{ cover.COVER_DESC }}</h1>
                </div>
                <div class="w-col w-col-2"><img src="@/assets/images/tooltip.png" loading="lazy" alt="" class="tooltip_icon" /></div>
              </div>
            </div>
            <div :class="['coverings_bloc_1', item.ZZSELECTED_IND ? 'covering_bloc_featured' : '']" v-for="item in data.CT_PACKAGES" :key="`${item.PACKAGE_ID}${cover.COVER_ID}`">
              <button
                v-if="isCoverinPackage(cover.COVER_ID, item.PACKAGE_ID)"
                type="button"
                :class="['covering_radio_button w-inline-block', isOptionalCoverSelected(cover.COVER_ID, item.PACKAGE_ID) ? 'active' : '']"
                @click="selectOptionalCover(cover, item)"
              />
            </div>
          </template>
          <!-- <div id="w-node-_1376b179-62a0-9953-bdb5-72e91dda51d8-9d3646d9" class="coverings_bloc_1 covering_bloc_transparent">
            <h1 class="heading-8">{{$t('COMPANY_STATEMENT')}}</h1>
            <h1 class="heading-8 heading_2_covering">
              {{$t('COMPANY_DECLERATION_DETAILS')}}
            </h1>
          </div>
          <div id="w-node-b13e454f-2e13-6bdb-11d0-e86ea00b4d41-9d3646d9" class="covering_bloc_transparent">
            <validation-provider class="w-100" :name="$t('EMAIL')" rules="required|email" v-slot="{ errors, classes }">
              <input
                type="text"
                class="text_field_input cover_input w-input"
                maxlength="256"
                name="name-2"
                data-name="Name 2"
                placeholder="your-email@email.com"
                id="name-2"
                v-model="data.CS_CONFIRMATION.EMAIL"
              />
              <span :class="classes">{{ errors[0] }}</span>
            </validation-provider>
          </div>
          <div id="w-node-_19688e8c-443e-d0c2-61e7-a12fa37d08d3-9d3646d9" class="coverings_bloc_1 covering_bloc_transparent cta_bloc_covering">
            <button type="submit" class="cover_submit_button w-button">{{$t('PAYMENT')}} {{$u.formatMoney(getSelectedPackage.AMOUNT)}}</button>
          </div> -->
        </form>
      </validation-observer>
    </div>
    <div class="cta_offer_block">
      <div class="w-form">
        <validation-observer v-slot="{ handleSubmit, reset }">
          <form @submit.prevent="handleSubmit(submitSendEmailForm)" @reset.prevent="reset" id="email-form" name="email-form" data-name="Email Form" class="form-5">
            <div class="columns-10 w-row">
              <div class="column-35 w-col w-col-4">
                <h1 class="heading-8">{{$t('COMPANY_STATEMENT')}}</h1>
                <p class="bold_label paragraph_offer">
                  {{$t('COMPANY_DECLERATION_DETAILS')}}
                </p>
              </div>
              <div class="column-36 w-col w-col-6">
                <h1 class="heading-8">{{$t('SEND_OFFER')}}</h1>
                <validation-provider class="w-100" :name="$t('EMAIL')" rules="required|email" v-slot="{ errors, classes }">
                  <input
                    type="text"
                    class="text_field_input cover_input w-input"
                    maxlength="256"
                    name="name-2"
                    data-name="Name 2"
                    placeholder="your-email@email.com"
                    id="name-2"
                    v-model="data.CS_CONFIRMATION.EMAIL"
                  />
                  <span :class="classes">{{ errors[0] }}</span>
                </validation-provider>
              </div>
              <div class="column-34 w-col w-col-2">
                <button type="submit" class="cover_submit_button w-button">{{$t('SUBMIT')}}</button>
              </div>
            </div>
          </form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    getMandatoryCovers() {
      const covers = Array.from(new Set(this.data.CT_COVERS.map((a) => a.COVER_ID)))
        .map((id) => this.data.CT_COVERS.find((o) => o.COVER_ID === id))
        .filter((o) => o.ZZMANDATORY_IND);
      return covers;
    },
    getOptionalCovers() {
      const covers = Array.from(new Set(this.data.CT_COVERS.map((a) => a.COVER_ID)))
        .map((id) => this.data.CT_COVERS.find((o) => o.COVER_ID === id))
        .filter((o) => !o.ZZMANDATORY_IND);
      return covers;
    },
    getSelectedPackage() {
      return this.data.CT_PACKAGES.filter((o) => o.ZZSELECTED_IND)[0];
    }
  },
  methods: {
    isCoverinPackage(coverId, packageId) {
      return !!this.data.CT_COVERS.filter((o) => o.COVER_ID === coverId && o.PACKAGE_ID === packageId).length;
    },
    isOptionalCoverSelected(coverId, packageId) {
      return !!this.data.CT_COVERS.filter((o) => o.COVER_ID === coverId && o.PACKAGE_ID === packageId && o.ZZSELECTED_IND).length;
    },
    selectPackage(item) {
      this.$emit('select-package', item);
    },
    selectOptionalCover(cover, selPackage) {
      const selectedCover = this.data.CT_COVERS.filter((o) => o.COVER_ID === cover.COVER_ID && o.PACKAGE_ID === selPackage.PACKAGE_ID)[0];
      this.$emit('select-cover', { CT_COVERS: [{ ...selectedCover }], CT_PACKAGES: [{ ...selPackage }] });
    },
    submitForm() {
      this.$emit('next');
    },
    submitSendEmailForm() {
      console.log('send-email');
      this.$emit('send-email');
    }
  }
};
</script>
